import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Articulos from '../Articulos/Articulos';

const VISTA_MODAL_KEY = 'pref_vista_modal';
const TEMA_KEY = 'pref_tema';

const leerPreferencia = (key, porDefecto) => {
    try {
        return localStorage.getItem(key) || porDefecto;
    } catch {
        return porDefecto;
    }
};

const guardarPreferencia = (key, valor) => {
    try {
        localStorage.setItem(key, valor);
    } catch {
        // Sin almacenamiento disponible: la preferencia dura hasta cerrar la app
    }
};


export default function Layout() {

    const navigate = useNavigate()

    const [vistaModal, setVistaModal] = useState(() => leerPreferencia(VISTA_MODAL_KEY, 'selector'));
    const [tema, setTema] = useState(() => leerPreferencia(TEMA_KEY, 'claro'));

    const cambiarVistaModal = (vista) => {
        setVistaModal(vista);
        guardarPreferencia(VISTA_MODAL_KEY, vista);
    };

    const cambiarTema = (nuevoTema) => {
        setTema(nuevoTema);
        guardarPreferencia(TEMA_KEY, nuevoTema);
    };

    // Aplica el tema (claro / oscuro / según el sistema) a toda la app
    useEffect(() => {
        const media = window.matchMedia('(prefers-color-scheme: dark)');

        const aplicar = () => {
            const oscuro = tema === 'oscuro' || (tema === 'sistema' && media.matches);
            document.documentElement.classList.toggle('dark', oscuro);
            document.querySelector('meta[name="theme-color"]')?.setAttribute('content', oscuro ? '#0f172a' : '#ffffff');
        };

        aplicar();

        if (tema === 'sistema') {
            media.addEventListener('change', aplicar);
            return () => media.removeEventListener('change', aplicar);
        }
    }, [tema]);


    const logout = async () => {
        try {
            localStorage.removeItem('auth_usuario');
            navigate('/login');
        } catch (error) {
            console.log(error.response?.data?.message);
        }
    };

    return (

        <>
            <div className='flex min-h-[100dvh] flex-col bg-slate-50 dark:bg-slate-950'>
                <Navbar
                    logout={logout}
                    vistaModal={vistaModal}
                    cambiarVistaModal={cambiarVistaModal}
                    tema={tema}
                    cambiarTema={cambiarTema}
                />
                <div className='flex flex-grow flex-col'>
                    <Articulos logout={logout} vistaModal={vistaModal} />
                </div>
            </div>


        </>

    )


}
